import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoaderState {
  show: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private _stacks = 0;
  public loaderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  open() {
    this._stacks++;
    console.log('[LoaderService] open -> stacks:', this._stacks);
    if (this._stacks > 0) {
      this.loaderSubject.next(true);
    }
  }
  close() {
    this._stacks--;
    console.log('[LoaderService] close -> stacks:', this._stacks);
    if (this._stacks < 0) {
      this._stacks = 0;
    }
    if (this._stacks === 0) {
      this.loaderSubject.next(false);
    }
  }
}
